var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8C5.55228 8 6 8.44772 6 9Z",
    fill: "#F09103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9Z",
    fill: "#F09103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 9.55228 11.5523 10 11 10C10.4477 10 10 9.55228 10 9C10 8.44772 10.4477 8 11 8C11.5523 8 12 8.44772 12 9Z",
    fill: "#F09103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31C26 32.1046 25.1046 33 24 33C22.8954 33 22 32.1046 22 31C22 29.8954 22.8954 29 24 29C25.1046 29 26 29.8954 26 31Z",
    fill: "#F09103"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40.6L2.67135e-06 7.4C2.778e-06 6.07453 1.0745 5 2.4 5L45.6 5C46.9255 5 48 6.07451 48 7.40001L48 40.6C48 41.9255 46.9255 43 45.6 43L2.4 43C1.07452 43 -1.06651e-07 41.9255 0 40.6ZM2 40.6L2 7.4C2 7.17909 2.17909 7 2.4 7L45.6 7C45.8209 7 46 7.17909 46 7.40001L46 40.6C46 40.8209 45.8209 41 45.6 41L2.4 41C2.17908 41 2 40.8209 2 40.6Z",
    fill: "#165297"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 11.4477 4.44772 11 5 11H43C43.5523 11 44 11.4477 44 12C44 12.5523 43.5523 13 43 13H5C4.44772 13 4 12.5523 4 12Z",
    fill: "#165297"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 26V36H30V26H18ZM17 24C16.4477 24 16 24.4477 16 25V37C16 37.5523 16.4477 38 17 38H31C31.5523 38 32 37.5523 32 37V25C32 24.4477 31.5523 24 31 24H17Z",
    fill: "#165297"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 24V21C27 19.3431 25.6569 18 24 18C22.3431 18 21 19.3431 21 21V24H27ZM24 16C21.2386 16 19 18.2386 19 21V25C19 25.5523 19.4477 26 20 26H28C28.5523 26 29 25.5523 29 25V21C29 18.2386 26.7614 16 24 16Z",
    fill: "#165297"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9874e9a225c49170d23dd5a47f985bc2.svg";
export { ForwardRef as ReactComponent };